<div class="mainMenu">
  <a *ngIf="isLoggedin()" class="elink" routerLink="/dashboard" (click)="toggleMenu()">Dashboard</a>
  <a *ngIf="!isLoggedin() && isShowRef" class="elink" [href]="redirectUrl">Home</a>
  <a *ngIf="!isLoggedin() && !isShowRef" class="elink" [href]="redirectUrl">Home</a>
  <a class="elink" routerLink="/info/about-us" (click)="toggleMenu()">About us</a>
  <a class="elink" routerLink="/info/contact-us" (click)="toggleMenu()">Contact us</a>
  <a *ngIf="!isLoggedin()" class="elink" routerLink="/login" (click)="toggleMenu()">Login</a>
  <a *ngIf="isShowRef" routerLink="/referral" class="elink" (click)="toggleMenu()">Referral</a>
  <a *ngIf="isLoggedin()" class="elink">Welcome {{firstName}}</a>
  <a *ngIf="isLoggedin()" class="elink" (click)="logout()" tabindex="0">Logout</a>
</div>